import { ErrorMessageFromJSONTyped } from '../../generated-api';
import { ApiError } from '../api';

type ProblemDetail = {
  detail: string;
  title?: string;
};

const hasDetail = (x: unknown): x is ProblemDetail => !!x && typeof x === 'object' && 'detail' in x;

export class NetworkError extends Error {
  constructor(public originalError: unknown) {
    super('Network error: No response from server. Please check your internet connection.');
    this.name = 'NetworkError';
  }
}

export const parseError = async (err: unknown) => {
  if (!(err instanceof ApiError) || !err.response) {
    throw new NetworkError(err);
  }

  const { response, errorBody, message } = err;

  if (errorBody) {
    if (hasDetail(errorBody)) {
      const problemDetail = errorBody as ProblemDetail;
      throw new ApiError(response, null, `Operation failed: ${problemDetail.detail}`, problemDetail.title ?? 'Error');
    }

    try {
      throw ErrorMessageFromJSONTyped(errorBody, true);
    } catch (e) {
      if (e instanceof Error) {
        throw e;
      } else {
        throw new Error(`Failed to parse error body: ${message}`, { cause: e });
      }
    }
  }

  throw new Error(message || `HTTP ${response.status}`);
};
